module.exports = __webpack_public_path__ + "img/select.0943c18a.svg";